<template>
  <div class="py-[10px]">
    <div class="title__wrapper relative ">
      <span class="title__name relative text-[18px] text-[#000] font-500">{{ title }}</span>
      <span class="title__sub text-xs text-[#62676D] ml-[15px]" v-if="subtitle">{{ subtitle }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: "CruiseDetailSloodeRight",
  components: {
  },
  props: {
    title: '',
    subtitle: '',
    data: {
      type: Object,
      default: () => ({
        images: []
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.title__wrapper {
  padding-left: 13px;
}
.title__wrapper::before {
  content: "";
  position: absolute;
  top: 50%;
  margin-top: -10px;
  left: 0;
  width: 5px;
  height: 20px;
  border-radius: 30px;
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
}
</style>
